export const EditReferencesComponents = {
  Default: 'DefaultEditReferences',
  Error: 'ErrorNotification',
  SelectExistingDocument: 'SelectExistingDocument'
};